import InfiniteScrollDropdown from './InfiniteScrollDropdown';

export default InfiniteScrollDropdown;
